import React from "react";
import PropTypes from 'prop-types';

const LevtyButton = ({
  label,
  onClick,
  block,
  disabled,
  loading,
  size,
  color,
  type
}) => {

  return (
    <>
      {!!label &&
        <div   translate="no" style={{ display: "flex", justifyContent: "center" }}>
          <button
            type={type}
            className={`btn btn-${size} btn-${color} d-none d-lg-block ${block && 'btn-block'}`}
            disabled={disabled}
            onClick={onClick}
          >
            {loading ?
              <div   translate="no" className="notranslate spinner-border" style={{ width: "20px", height: "20px" }} role="status">
                <span   translate="no" className="notranslate sr-only">Loading...</span>
              </div>
              :
              label
            }
          </button>

          <button
            type={type}
            className={`btn btn-${color} d-lg-none ${block && 'btn-block'}`}
            disabled={disabled}
            onClick={onClick}
          >
            {loading ?
              <div   translate="no" className="notranslate spinner-border" style={{ width: "20px", height: "20px" }} role="status">
                <span   translate="no" className="notranslate sr-only">Loading...</span>
              </div>
              :
              label
            }
          </button>
        </div>
      }
    </>
  );
}

LevtyButton.defaultProps = {
  block: false,
  disabled: false,
  loading: false,
  size: 'lg',
  color: 'primary',
  type: 'button'
}

LevtyButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.oneOf(['lg', 'sm', 'md']),
  color: PropTypes.oneOf(['light', 'primary', 'link']),
  type: PropTypes.oneOf(['button', 'submit'])
}

export default LevtyButton;
